import axios from "axios";

export default {

    data:() => ({

    }),

    methods: {
        abbrNum(number, decPlaces) {
            // 2 decimal places => 100, 3 => 1000, etc
            decPlaces = Math.pow(10,decPlaces);

            // Enumerate number abbreviations
            var abbrev = [ "K", "M", "B", "T" ];

            // Go through the array backwards, so we do the largest first
            for (var i=abbrev.length-1; i>=0; i--) {

                // Convert array index to "1000", "1000000", etc
                var size = Math.pow(10,(i+1)*3);

                // If the number is bigger or equal do the abbreviation
                if(size <= number) {
                    // Here, we multiply by decPlaces, round, and then divide by decPlaces.
                    // This gives us nice rounding to a particular decimal place.
                    number = Math.round(number*decPlaces/size)/decPlaces;

                    // Handle special case where we round up to the next abbreviation
                    if((number === 1000) && (i < abbrev.length - 1)) {
                        number = 1;
                        i++;
                    }

                    // Add the letter for the abbreviation
                    number += abbrev[i];

                    // We are done... stop
                    break;
                }
            }

            return number;
        },

        numberFormat(number) {
            return new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)
        },

        getRandomColor() {
            const randomInt = (min, max) => {
                return Math.floor(Math.random() * (max - min + 1)) + min;
            };

            return () => {
                var h = randomInt(0, 360);
                var s = randomInt(42, 98);
                var l = randomInt(40, 90);
                return `hsl(${h},${s}%,${l}%)`;
            };
        },

        sum(array, key) {
           return array.reduce((a, b) => a + (parseInt(b[key]) || 0), 0);
        },

        async getBenchmarkData(ownPage) {
            await axios.request({
                method: 'post',
                baseURL: process.env.VUE_APP_ROOT_API,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer 6ff28042-50cf-41fe-a557-67a385223d4d'
                },
                data: {
                    "jsonrpc": "2.0",
                    "id": 1,
                    "method": "partner_api.get_benchmark_data",
                    "params": {
                        "projectname": ownPage.project_name,
                        "brandname": "fb",
                        "date": {
                            "start": this.dateTime.startDate,
                            "end": this.dateTime.endDate
                        },
                    }
                },
            }).then((response) => {
                this.$store.dispatch('setPages',response);
            }).catch(() => {

            });
        },

        async getMonitoredProfiles() {
            await axios.request({
                method: 'post',
                baseURL: process.env.VUE_APP_ROOT_API,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer 6ff28042-50cf-41fe-a557-67a385223d4d'
                },
                data: {
                    "jsonrpc": "2.0",
                    "id": 1,
                    "method": "partner_api.get_monitored_profiles",
                    "params": {
                        "platform": "fb",
                    }
                },
            }).then((response) => {
                var data = response.data.result;

                var myApps = data.map(project => {
                    var i = project.profiles.find(profile => {
                        return profile.isOwn !== undefined;
                    });

                    if (i !== undefined) {
                        return {
                            id: i.id,
                            project_name: project.projectname,
                            favourite: i.id === "1589379301391164",
                        };
                    }
                    return false;
                }).filter(j => {
                    return j !== false;
                });

                this.$store.dispatch('addMyApp',myApps);

            }).catch(() => {

            });
        },
    }
}
